import React, { ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  AcceptedFileTypes,
  AcceptedFileTypesArray,
  APPLICATION_ID,
  authFeatureConstants,
  Base64Image,
  DOCUMENT_TYPE_INFRA_PHOTOS,
  ImageMaxSize,
} from '../../../../../../shared/constants/commonConstants';
import {
  FetchFileByteRequest,
  FileByteDetail,
} from '../../../../../../shared/models/file.profile.model';
import './Photos.less';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Dragger from 'antd/lib/upload/Dragger';
import { UploadChangeParam, UploadFile } from 'antd/lib/upload/interface';
import { canActivate, error } from '../../../../../../utils/utility';
import { Skeleton } from 'antd';
import { fetchInfraImages } from '../../../../../../store/actions/hospitalAction';
import {ReactComponent as UploadIcon} from '../../../../../../assets/images/svg/i_upload.svg';

const Photos = ({ photos, heading }: any): ReactElement => {
  const [previewList, setPreviewList] = useState([] as string[]);
  let pElement: any;
  const [files, updateFiles] = useState([] as any);
  const ref = useRef({ photosForLterUse: [] as any, inActiveList: [] as any });
  const apiHospitalProfile = useSelector(
    ({ hospital: { hospitalProfile } }: any): any => hospitalProfile,
  );
  const infraImageDetails = useSelector(({ hospital: { infraImages } }: any): any => infraImages);
  const [isAPICall, setIsAPICall] = useState(true);
  const dispatch = useDispatch();
  const infinite = previewList.length > 4;
  const sliderSettings = {
    dots: false,
    infinite,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: 'linear',
  };

  useEffect((): void => {
    setIsAPICall(true);
    if (
      apiHospitalProfile &&
      apiHospitalProfile.length > 0 &&
      apiHospitalProfile[0] &&
      apiHospitalProfile[0].documentDetails &&
      apiHospitalProfile[0].documentDetails.length > 0 &&
      apiHospitalProfile[0].documentDetails.filter(
        (x: any): boolean =>
          x.typeName === DOCUMENT_TYPE_INFRA_PHOTOS && x.isActive,
      ).length > 0
    ) {
      const fileIdentifiers: string[] = apiHospitalProfile[0].documentDetails
        .filter(
          (x: any): boolean =>
            x.typeName === DOCUMENT_TYPE_INFRA_PHOTOS && x.isActive,
        )
        .map((item: any): string => {
          return item.docId;
        });
      addPhotosToPreviewList(fileIdentifiers);
    } else {
      setIsAPICall(false);
    }
  }, [apiHospitalProfile]);

  useEffect((): void => {
    if (infraImageDetails) {
      setIsAPICall(false);
      const previouslyUploadedPhotos: string[] = infraImageDetails.map(
        (item: FileByteDetail): any => {
          return { src: Base64Image.concat(item.fileBytes), file: item, isActive: true };
        },
      );
      ref.current.photosForLterUse = [...previouslyUploadedPhotos];
      setPreviewList([...previouslyUploadedPhotos]);
    }
  }, [infraImageDetails]);

  const addPhotosToPreviewList = async (
    fileIdentifiers: string[],
  ): Promise<void> => {
    if (fileIdentifiers.length > 0) {
      const payload: FetchFileByteRequest = {
        applicationId: APPLICATION_ID,
        fileIdentifiers,
      };
      setIsAPICall(true);
      dispatch(fetchInfraImages(payload));
    }
  };

  if (previewList != null && previewList.length > 0) {
    pElement = previewList.map(
      (item: any, id: number): ReactNode => {
        return (
          <div key={id} className="slider-item">
            <img
              src={item.src}
              alt={item.src}
            />
            <div className="delete-image" onClick={(e: any): void => { e.stopPropagation(); onSliderImageClick(item); }}>
              <span>Delete</span>
            </div>
          </div>
        );
      },
    );
  }

  const onSliderImageClick = (photo: any): void => {
    const tempPreviewList = [...previewList];
    const activePreviewList = tempPreviewList.filter((x: any): any => {
      if (x?.file?.fileGuid && photo?.file?.fileGuid) {
        return x.file.fileGuid !== photo.file.fileGuid;
      } else if (photo.file.uid && x.file.uid) {
        return x.file.uid !== photo.file.uid;
      } else {
        return true;
      }
    });
    const inActivePreviewList = ref.current.photosForLterUse.filter((x: any): any => {
      if (x?.file?.fileGuid && photo?.file?.fileGuid) {
        return x.file.fileGuid === photo.file.fileGuid;
      } else if (photo.file.uid && x.file.uid) {
        return x.file.uid === photo.file.uid;
      }
    }).map((y: any): any => ({ ...y, isActive: false }));
    ref.current.inActiveList = [...ref.current.inActiveList, ...inActivePreviewList];

    setPreviewList([...activePreviewList]);
    photos([...activePreviewList, ...ref.current.inActiveList].map((x: any): any => x));
  };

  const fileUploadHandler = {
    files,
    multiple: true,
    showUploadList: false,
    beforeUpload: (file: any): any => {
      let response = true;
      if (!AcceptedFileTypesArray.includes(file.type)) {
        error('File type not allowed');
        response = false;
      }
      if (file.size > ImageMaxSize) {
        error('File size should not be greater than 10mb');
        response = false;
      }
      return response;
    },
    onChange: ({ fileList }: UploadChangeParam): any => {
      // file.status is empty when beforeUpload return false
      const validFiles = fileList.filter(
        (file: UploadFile): boolean =>
          !!file.status &&
          files.filter((x: any): boolean => file.uid === x.uid).length === 0,
      );
      if (validFiles && validFiles.length > 0) {
        const objectsUrls: any[] = [];
        validFiles.forEach((file: any): void => {
          objectsUrls.push({ src: URL.createObjectURL(file.originFileObj), file: file.originFileObj, isActive: true });
        });
        const tempPhotos = [...previewList, ...objectsUrls];
        ref.current.photosForLterUse = [...tempPhotos];
        setPreviewList(tempPhotos);
        photos([...tempPhotos, ...ref.current.inActiveList]);
        updateFiles([
          ...files,
          ...validFiles.filter((file: UploadFile): boolean => !!file.status),
        ]);
      }
    },
  };
  return (
    <React.Fragment>
      <h5 className="h5">{heading}</h5>
      {isAPICall ? (
        <Skeleton active={true} paragraph={{ rows: 3 }} />
      ) : (
          pElement && <Slider className="hospital-slider mb-md" {...sliderSettings}> {pElement}</Slider>
        )}
      {
        canActivate(authFeatureConstants.EDIT_HOSPITAL_PROFILE) &&
        <Dragger {...fileUploadHandler} accept={AcceptedFileTypes}>
          <p className="text-center"><UploadIcon className="fill-primary" /></p>
          <p className="ant-upload-text">Drag & Drop your file here</p>
          <p className="ant-upload-hint">
            File format needs to be .png, .jpg, .gif
        </p>
        </Dragger>
      }
    </React.Fragment>
  );
};
export default Photos;
